<template>
    <div class="h-screen overflow-hidden login-customer bg-white lg:bg-gray-100 flex items-center justify-center relative">
        <div class="container mx-auto">
            <div class="bg-white p-4 lg:p-8 mt-4 lg:border lg:shadow-xl rounded-xl max-w-sm mx-auto relative z-50">
                <img class="mx-auto max-w-[120px]" src="@/assets/logo-colorida.png" alt="">
                <h2 class="text-md font-bold text-center my-2 text-gray-500">Recuperar Senha</h2>

                <hr class="block mb-4">

                <form @submit.prevent="submitForm">
                    <div class="p-field mb-5">
                        <label for="username" class="text-sm font-bold">CPF/CNPJ</label>
                        <InputText type="text" id="email-login-customer" class="block w-full p-2 border rounded-xl" placeholder="Digite seu CPF/CNPJ" v-model="document" />
                    </div>

                    <Button type="submit" class="py-2 px-5 w-full rounded-xl bg-blue-800 hover:bg-blue-900 text-white shadow-none mb-3" :disabled="loading" :label="loading ? `Aguarde...` : `Recuperar Senha`" />
                    
                    <RouterLink to="/" class="text-sm font-bold text-center block text-blue-800">Voltar para o Login</RouterLink>
                </form>
            </div>

            <Toast></Toast>
            <FloatButton></FloatButton>
        </div>

        <img width="100%" class="opacity-10 object-cover absolute bottom-[-50%] left-0" src="@/assets/bg-tracking.webp" alt="">
    </div>
</template>

<script>
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import FloatButton from '@/components/Geral/FloatButton.vue'
import axios from 'axios'
import authService from '@/services/authService'

export default {
    name: 'CustomerForgotPassword',
    data() {
        return {
            document: null,
            loading: false
        }
    },
    methods: {
        async submitForm() {
            if (!this.document) {
                this.$toast.add({ severity: 'warn', summary: 'Campo Vazio!', detail: 'Por favor, preencha o campo de CPF/CNPJ.', life: 3000 });
                return false;
            }

            try {
                this.loading = true
                const response = await axios.post('/customer/forgot-password', {
                    document: this.document
                })
                this.loading = false

                if (response.data.status !== 200) {
                    this.$toast.add({ severity: 'error', summary: 'Erro!', detail: response.data.message || 'Erro ao processar solicitação.', life: 3000 });
                    return false
                }

                this.$toast.add({ severity: 'success', summary: 'Sucesso!', detail: 'Instruções para recuperação de senha foram enviadas.', life: 3000 });
                setTimeout(() => {
                    this.$router.push('/')
                }, 1500)
            } catch (error) {
                this.loading = false
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Erro ao solicitar recuperação!', 
                    detail: 'Verifique com o suporte.', 
                    life: 3000 
                });
                console.log(error)
            }
        },
        async isAuthenticated() {
            const request = await authService.isAuthenticated()

            if (!request) {
                return
            }

            if (request.request.status && request.request.status === 200) {
                this.$router.push('/area-cliente')
            }
        }
    },
    mounted() {
        this.isAuthenticated()
    },
    components: {
        InputText, Button, FloatButton
    }
}
</script>

<style lang="scss" scoped>
</style>
